import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import "../BookDetails/BookDetails.css";
import Loader from "../Loader/Loader.jsx";
import { FaArrowLeft, FaExpand } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header.jsx';
import { api } from '../../config.js';
//import { Helmet } from 'react-helmet-async';
const EPDF = () => {
    const { id } = useParams();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dataLoaded, setDataLoaded] = useState(false);
    const navigate = useNavigate();
    const iframeRef = useRef(null); // Reference to the iframe
    const getBookDetails = async () => {
      try {
        const response = await fetch(`${api}/book_author/book/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
       
        const data = await response.json();
        setBook(data);
        setDataLoaded(true);       
      } catch (error) {
        console.error('Error fetching book details:', error);
      }
    };

     const sendCounterUpdate = async () => {
    try {
      // Assume your backend expects a POST request to increment the counter
      const response = await fetch(`${api}/book_author/counter_readers`, {
        method: 'POST', // Use 'POST' or 'PUT' as required by your backend
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ count: 1,
                            book_id: id,
        }), // Sending a fixed count of 1 for every load
      });

      if (!response.ok) {
        // If the response is not OK, log or handle error
        throw new Error('Failed to send counter update to backend');
      }

      // Optionally handle the response data
      const data = await response.json();
     
    } catch (error) {
      console.error('Error sending counter update:', error);
    }
  };

  useEffect(  ()  =>  {
     getBookDetails();
    sendCounterUpdate();
    }, []);
   const handleprev = () => {
     //if user came from outsite the website redirect to / otherwise go back -1 brzkh
     if (window.history.state && window.history.state.idx > 0) { 
       navigate(-1);
     } else {
       navigate('/');
     }
   }
    const toggleFullscreen = () => {
        if (iframeRef.current) {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
              iframeRef.current.style.position = 'fixed';
              iframeRef.current.style.top = '0';
              iframeRef.current.style.left = '0';
              iframeRef.current.style.width = '100%';
              iframeRef.current.style.height = '100%';
              iframeRef.current.style.zIndex = '9999';
            }
        }
    };

    useEffect(() => {
     
      if (book && dataLoaded) {
        const iphone = /iphone/i.test(window.navigator.userAgent);
        if (iphone) {
             window.location.href  =  book?.book_url;
        }
        // const stripHtmlTags = (html) => {
        //   const doc = new DOMParser().parseFromString(html, 'text/html');
        //   return doc.body.textContent || "";
        // };
        // const plainTextDescription = stripHtmlTags(book?.description ? book.description.slice(0, 170) : "مجمع الملك سلمان العالمي للغة العربية - المكتبة الرقمية - " + book?.title || "");
        // document.querySelector('meta[name="description"]').content = plainTextDescription;
        // document.querySelector('meta[name="author"]').content = `${book?.authors}`;
        // document.querySelector('link[rel="canonical"]').href = `${window.location.href}`;
      }
    } , [book, dataLoaded]);

      return (
        <>
          {/* <Helmet>
          <title>{book?.title + " - مجمع الملك سلمان العالمي للغة العربية"}</title> 
            <meta 
            name="description" 
            content={book && book.description ? book.description.slice(0, 170) : "مجمع الملك سلمان العالمي للغة العربية - المكتبة الرقمية - " + book?.title} 
          />
            <meta name="author" content={book?.authors} />
            <link rel="canonical" href={`https://library.ksaa.gov.sa/index/view/${book?.book_id}`} />
          </Helmet> */}
        <Header />
        <section className='book-details'>
            <div className='container'>
                {!loading ? <Loader /> : (
                    <>
                        <button type='button' className='flex flex-c back-btn ' style={{ color: '#024e28' }} onClick={handleprev}>
                            <FaArrowLeft size={22} style={{ transform: 'rotate(180deg)', marginLeft: '5px' }} />
                            <span className='fs-18 fw-6'> السابق</span>
                        </button>
                        <div className=''>
                        <button className="book-details-btn btn-professional" onClick={toggleFullscreen}>
                        <span className='fs-18 fw-6'>  <FaExpand /> </span>
                        
                        </button>
                        </div>
                        <br/>
                        <div className='pdf-viewer' ref={iframeRef} style={{
                            position: "relative",
                            width: "100%",
                            height: "100vh",
                            overflow: "hidden"
                        }}>
                            <iframe
                                src={book?.book_url}
                                style={{
                                    border: "none",
                                    width: "100%",
                                    height: "100%"
                                }}
                                frameBorder="0"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </>
                )}
            </div>
        </section>
      </>
    );
};

export default EPDF;
